import { FC } from 'react';

import { css } from '@emotion/react';
import { ToucanColors } from '@jointoucan/toucan-design';
import { useTheme } from '@mui/material';

interface BorderedAreaProps {
  className?: string;
}

export const BorderedArea: FC<BorderedAreaProps> = ({ children, className }) => {
  const theme = useTheme();

  return (
    <div
      className={className}
      css={css`
        padding: ${theme.spacing(2)};
        border-radius: 4px;
        border: 1px solid ${ToucanColors.gray[200]};
      `}
    >
      {children}
    </div>
  );
};
